var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5808 4.932L15.5808 3.882C13.8248 2.961 12.9468 2.5 12.0028 2.5C11.0588 2.5 10.1808 2.96 8.42481 3.882L8.10381 4.051L17.0268 9.15L21.0428 7.14C20.3968 6.408 19.3548 5.861 17.5808 4.93M21.7508 8.464L17.7528 10.464V13.5C17.7528 13.6989 17.6738 13.8897 17.5331 14.0303C17.3925 14.171 17.2017 14.25 17.0028 14.25C16.8039 14.25 16.6131 14.171 16.4725 14.0303C16.3318 13.8897 16.2528 13.6989 16.2528 13.5V11.214L12.7528 12.964V22.404C13.4708 22.225 14.2878 21.797 15.5808 21.118L17.5808 20.068C19.7318 18.939 20.8078 18.375 21.4058 17.36C22.0028 16.346 22.0028 15.083 22.0028 12.56V12.443C22.0028 10.55 22.0028 9.366 21.7508 8.464ZM11.2528 22.404V12.964L2.25481 8.464C2.00281 9.366 2.00281 10.55 2.00281 12.441V12.558C2.00281 15.083 2.00281 16.346 2.59981 17.36C3.19781 18.375 4.27381 18.94 6.42481 20.069L8.42481 21.118C9.71781 21.797 10.5348 22.225 11.2528 22.404ZM2.96281 7.141L12.0028 11.661L15.4138 9.956L6.52781 4.878L6.42481 4.932C4.65181 5.862 3.60881 6.409 2.96281 7.142",
    fill: "#17282F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyorder);
export default __webpack_public_path__ + "static/media/myorder.c87b4a2bb2bf99ff387a166da693112d.svg";
export { ForwardRef as ReactComponent };